import React from 'react';
import { Reveal } from './Reveal';
import { SectionLabel } from './SectionLabel';
export function Transformation() {
  return <section aria-labelledby="transformacion-titulo" className="w-full bg-cream" data-id="element-192" data-mp="ilc6qm078osv">
      <div className="mx-auto grid max-w-6xl gap-12 px-5 py-16 sm:px-8 sm:py-24 lg:grid-cols-[1.05fr_0.95fr] lg:items-center" data-id="element-193" data-mp="mlcs6qlpu09f">
        <Reveal data-id="element-194" data-mp="rj4mfr9u1ygs">
          <SectionLabel data-id="element-195" data-mp="wkbtfo45itme">La transformación</SectionLabel>
          <h2 id="transformacion-titulo" className="mt-4 font-display text-3xl font-bold leading-[1.1] sm:text-[2.7rem]" data-id="element-196" data-mp="wjsn74nv5to7">
            No estás comprando un libro. Estás comprando{' '}
            <span className="text-clay" data-id="element-197" data-mp="16c83zynfcc7i">independencia</span>.
          </h2>
          <div className="mt-6 space-y-5 text-lg leading-relaxed text-graphite" data-id="element-198" data-mp="1ab76zdplhywb">
            <p data-id="element-199" data-mp="1fbux7x602bph">
              Cuando termines de leer Manos a la Casa, tu casa va a empezar a
              cambiar. No porque alguien vino a ayudarte, sino porque vos supiste
              cómo hacerlo.
            </p>
            <p data-id="element-200" data-mp="1c7l905egnozf">
              Vas a sentir la satisfacción de colgar tu primera repisa, poner las
              cortinas que compraste hace meses, acomodar esos cuadros que siguen
              en el piso y resolver pequeños arreglos que antes te generaban
              ansiedad.
            </p>
            <p className="font-display text-xl font-bold text-ink sm:text-2xl" data-id="element-201" data-mp="y7todltfvacg">
              Eso no tiene precio. Pero tiene un valor enorme para vos y para tu
              familia.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.08} data-id="element-202" data-mp="1qxaf8f1euj6k">
          <div className="overflow-hidden rounded-3xl border-2 border-ink shadow-block" data-id="element-203" data-mp="1m3o8f3hxh9io">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/ab2fa00c-89b7-4326-b2b5-4a1fed112700.jpg" alt="Repisa de madera recién instalada en la pared con plantas y cuadros, junto a cortinas colgadas" className="h-full w-full object-cover" data-id="element-204" data-mp="1h5d4f9ebdt8d" />
          </div>
        </Reveal>
      </div>
    </section>;
}